module.exports = __webpack_public_path__ + "img/bi.ebbe3791.svg";